import { animated, useSpring } from "react-spring"
import CarIconWrapper from "./components/CarIconWrapper"
import CarIcon from "./components/CarIcon"
import { AnimatedCarProps } from "./types"

const AnimatedCar = ({ options, iconSx }: AnimatedCarProps) => {
  const AnimatedWrapper = animated(({ children, ...other }) => (
    <CarIconWrapper {...other} label={options.label}>
      {children}
    </CarIconWrapper>
  ));
  const AnimatedIcon = animated((props) => (
    <CarIcon
      color={options.color}
      lightingColor={options.lightingColor}
      sx={iconSx}
      {...props}
    />
  ));
  const [wrapperStyles] = useSpring(() => options.wrapper || {}, []);
  const [iconStyles] = useSpring(() => options.icon || {}, []);

  return (
    <AnimatedWrapper style={wrapperStyles}>
      <AnimatedIcon style={iconStyles} />
    </AnimatedWrapper>
  );
};

export default AnimatedCar